/* global axios */
import ApiClient from './ApiClient';

class CustomerNotificationsAPI extends ApiClient {
  constructor() {
    super('customer_notifications', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  fetchOne(id) {
    return axios.get(`${this.url}/${id}`);
  }

  send(payload) {
    return axios.post(this.url, payload);
  }

  audienceCount(params = {}) {
    return axios.get(`${this.url}/audience_count`, { params });
  }
}

export default new CustomerNotificationsAPI();
